<!--页面代码从这里开始拷贝-->
<template>
  <div>
    <table-compnent
      :records="tableData"
      @resetHandler="reset"
      @searchHandler="doSearch"
      @queryByIdHandler="queryById"
      @deleteByIdHandler="deleteById"
      @batchDeleteHandler="batchDelete"
      @addHandler="saveSysUserLoginLog"
    >
      <template v-slot:search>
        <el-form-item label="手机号:">
          <el-input
            v-model="search.userName"
            placeholder="请输入手机号"
          ></el-input>
        </el-form-item>
      </template>
      <template v-slot:content>
        <el-table-column prop="username" label="登录手机号"></el-table-column>
        <el-table-column prop="clientId" label="ClientID"></el-table-column>
        <el-table-column prop="grantType" label="登录类型"></el-table-column>
        <el-table-column prop="ip" label="ip地址"></el-table-column>
        <el-table-column prop="platform" label="平台来源"></el-table-column>
        <el-table-column prop="createTime" label="创建时间"></el-table-column>
      </template>
    </table-compnent>  
  </div>
</template>

<script>
import TableCompnent from "@/components/table/TablesComponents";
import SysUserLoginLogApi from '@/api/SysUserLoginLogApi';
import { navTo,queryParam } from "@/utils/NavigatorUtils";
export default {
  name: "SysUserLoginLogList",
  props: {
    msg: String,
  },
  components: {
    TableCompnent
  },
  data() {
    return {
      tableData: {},
      search: {
        userName: "",
      },
      page:{}
    };
  },
  methods: {
    reset() {
      this.search = {};
    },
    doSearch(params) {
      this.page = params;
      this.search.pageSize = this.page.pageSize
      this.search.pageNum = this.page.pageNum
      SysUserLoginLogApi.search(this.search).then((resp)=>{
        if(resp.state=="OK"){
          this.tableData = resp.data
        }
      })
    },
    saveSysUserLoginLog(){
        navTo(this,"/saveSysUserLoginLog");
    },
    queryById(params){
      queryParam(this,"saveSysUserLoginLog",params.id);
    },
    deleteById(id){
      SysUserLoginLogApi.deleteSysUserLoginLog(id).then((resp)=>{
        if(resp.state=="OK"){
          this.doSearch(this.page)
        }else{
          this.$errorMsg(resp.msg)
        }
      })
    },
    batchDelete(params){
      SysUserLoginLogApi.batchDeleteSysUserLoginLog(params).then((resp)=>{
        if(resp.state=="OK"){
          this.$successMsg(resp.msg)
          this.doSearch(this.page)
        }else{
          this.$errorMsg(resp.msg)
        }
      })
    }
  },
};
</script>
<!--页面代码从这里结束拷贝-->